export default {
  fafuliApiUrl: function () {
    if (window.location.hostname === 'ui.fafuli.com') {
      return 'https://api.fafuli.com/'
    } else if (window.location.hostname === 'test-ui-new.fafuli.com') {
      return 'https://test-api-new.fafuli.com/'
    } else {
      return 'https://test-api.fafuli.com/'
    }
  },
  fafuliUrl: function () {
    if (window.location.hostname === 'ui.fafuli.com') {
      return 'https://www.fafuli.com/'
    } else if (window.location.hostname === 'test-ui-new.fafuli.com') {
      return 'https://test-new.fafuli.com/'
    } else {
      return 'https://test.fafuli.com/'
    }
  },
  fafuliMallAdminUrl: function () {
    if (window.location.hostname === 'ui.fafuli.com') {
      return 'https://admin.fafuli.com/'
    } else if (window.location.hostname === 'test-ui-new.fafuli.com') {
      return 'https://test-admin-new.fafuli.com/'
    } else {
      return 'https://test-admin.fafuli.com/'
    }
  },
  fafuliWxAdminUrl: function () {
    if (window.location.hostname === 'ui.fafuli.com') {
      return 'https://wx.fafuli.com/'
    } else if (window.location.hostname === 'test-ui-new.fafuli.com') {
      return 'https://test-wx-new.fafuli.com/'
    } else {
      return 'https://test-wx.fafuli.com/'
    }
  },
  fafuliAssembleApiUrl: function () {
    if (window.location.hostname === 'ui.fafuli.com') {
      return 'https://assemble-api.fafuli.com/'
    } else if (window.location.hostname === 'test-ui-new.fafuli.com') {
      return 'https://test-assemble-api-new.fafuli.com/'
    } else {
      return 'https://test-assemble-api.fafuli.com/'
    }
  },
  ssoUiUrl: function () {
    if (window.location.hostname === 'ui.fafuli.com') {
      return 'https://ui.fafuli.com/sso/#/'
    } else if (window.location.hostname === 'uat-ui.fafuli.com') {
      return 'https://uat-ui.fafuli.com/sso/#/'
    } else if (window.location.hostname === 'test-ui-new.fafuli.com') {
      return 'https://test-ui-new.fafuli.com/sso/#/'
    } else {
      return 'https://test-ui.fafuli.com/sso/#/'
    }
  },
  fulihuiApiUrl: function () {
    if (window.location.hostname === 'ui.fafuli.com') {
      return 'https://fulihui.fafuli.com/api/'
    } else if (window.location.hostname === 'uat-ui.fafuli.com') {
      return 'https://uat-fulihui.fafuli.com/api/'
    } else {
      return 'https://test-fulihui.fafuli.com/api/'
    }
  },
  localUrl () {
    if (window.location.hostname === 'ui.fafuli.com') {
      return 'https://ui.fafuli.com/assemble'
    } else if (window.location.hostname === 'localhost') {
      return 'http://localhost:8080/assemble'
    } else if (window.location.hostname === 'test-ui-new.fafuli.com') {
      return 'https://test-ui-new.fafuli.com/assemble'
    } else {
      return 'https://test-ui.fafuli.com/assemble'
    }
  }
}
